const initBlock = function( $block ) {
	$block.find( '.js-bio-toggle' ).on( 'click', function() {
		const $btn  = $( this );
		const $card = $btn.closest( '.section-partners__card' );
		const open  = $card.toggleClass( 'is-open' ).hasClass( 'is-open' );
		$btn.attr( 'aria-expanded', open ? 'true' : 'false' );
		$btn.find( 'span' ).text( open ? 'Show less' : 'Read full bio' );
	} );
};

app.loadBlock( initBlock, 'partners', '.section-partners' );

if ( module.hot ) {
	module.hot.accept();
}
